module.exports = __webpack_public_path__ + "img/frame (161).df450301.jpg";